import {useClientNavigationTabs} from '@/logged/features/aside-menu/composables/navigation/useClientNavigationTabs';
import {useUser} from '@/logged/features/user';
import {computed} from '@vue/reactivity';
import {NavigationTabsRecord} from './navigation.types';
import {useFreelanceNavigationTabs} from './useFreelanceNavigationTabs';

export function useNavigationTabs(): NavigationTabsRecord {
    const userStore = useUser();

    const freelance = useFreelanceNavigationTabs();
    const client = useClientNavigationTabs();

    const isFreelanceIdentity = computed(() => {
        return userStore.hasSelectedFreelanceIdentity || userStore.cachedIdentityRole === 'FREELANCE';
    });

    const allNavigationRoutes = computed(() => (isFreelanceIdentity.value ? freelance.allNavigationRoutes.value : client.allNavigationRoutes.value));
    const filteredNavigationRoutes = computed(() =>
        isFreelanceIdentity.value ? freelance.filteredNavigationRoutes.value : client.filteredNavigationRoutes.value,
    );
    const cachedNavigationRoutes = computed(() =>
        isFreelanceIdentity.value ? freelance.cachedNavigationRoutes.value : client.cachedNavigationRoutes.value,
    );

    const logoNavigationRoute = computed(() =>
        userStore.hasSelectedFreelanceIdentity ? freelance.logoNavigationRoute.value : client.logoNavigationRoute.value,
    );

    return {
        logoNavigationRoute,
        allNavigationRoutes,
        filteredNavigationRoutes,
        cachedNavigationRoutes,
    };
}
